<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Editar cita</span>
        </v-card-title>
        <v-card-text>
          <VisitForm
            :host_custon_hosts="host_custon_hosts"
            :visitForm="visitForm"
            :collaborators="collaborators"
            @formMounted="onMountedForm"
            @onCollaboratorSelected="onCollaboratorSelected"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="working.wUpdate" flat @click="cancel"
            >Cancelar</v-btn
          >
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            @click="submit"
            flat
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..." />
    <success v-model="toast.success" text="Creación Exitosa" />
    <error v-model="toast.failed" :text="toast.eMessage" />
  </div>
</template>

<script>
import loading from "../../Dialogs/Loading.vue";
import success from "../../Dialogs/Success.vue";
import error from "../../Dialogs/Error.vue";
import VisitForm from "./VisitForm";

export default {
  props: ["value", "visit", "collaborators"],
  components: {
    loading,
    success,
    error,
    VisitForm,
  },
  watch: {
    value() {
      if (this.value) {
        if (this.visit !== null) {
        this.visitForm.name = this.visit.name;
					this.visitForm.reason = this.visit.reason;
          this.visitForm.collaborators = this.visit.hosts;
					// this.visitForm.idCollaborator = this.visit.collaborator.id;
					// this.visitForm.collaborators = [{ id: this.visit.collaborator.id }];
					this.visitForm.date = this.visit.date;
					this.visitForm.startDate = this.visit.startDate;
					this.visitForm.endDate = this.visit.endDate;
					this.visitForm.visitType = this.visit.visitType;

          this.host_custon_hosts = structuredClone(this.visit)
        }
      }
    },
  },
  data: () => ({
    host_custon_hosts: {},
    visitForm: {
     name: "",
			reason: "",
			collaborators: [],
			date: null,
			startDate: null,
			endDate: null,
      visitType: 'ONLY_ONCE',
    },
    working: {
      wUpdate: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: "",
    },
    vueForm: null,
  }),
  methods: {
    onCollaboratorSelected(collaborators){
      this.visitForm = { ...this.visitForm, collaborators, }
    },
    onMountedForm(form) {
      this.vueForm = form;
    },
    submit() {
      this.vueForm.$touch();
      if (this.vueForm.$invalid) {
        return;
      }

      this.working.wUpdate = true;
      this.$store
        .dispatch("visits/updateVisit", {
          id: this.visit.id,
          data: this.visitForm,
        })
        .then((response) => {
          this.working.wUpdate = false;
          this.vueForm.$reset();
          this.$emit("created", true, response.data);
          this.close();
        })
        .catch(() => {
          this.working.wUpdate = false;
          this.$emit("created", false, null);
        });
    },
    cancel() {
      this.$emit("cancelled");
      this.close();
      console.log("cerrado")
    },
    close() {
      this.vueForm.$reset();
      this.visitForm = {
        name: "",
        reason: "",
      };
    },
  },
  computed: {},
};
</script>

<style>
</style>
